"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ButtonContext = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var React = _interopRequireWildcard(require("react"));

var _reduxForm = require("redux-form");

var _reactRouterDom = require("react-router-dom");

var _reactScroll = require("react-scroll");

var _utils = require("../utils");

var _gaPushToDataLayer = _interopRequireDefault(require("../utils/gaPushToDataLayer"));

var _Header = _interopRequireDefault(require("../components/Header/Header"));

var _ProgressBar = _interopRequireDefault(require("../ui/ProgressBar"));

var _PaymentFormWrapper = _interopRequireDefault(require("./PaymentFormWrapper"));

var _Button = _interopRequireDefault(require("./Button"));

var _Footer = _interopRequireDefault(require("./Footer"));

var _types = require("../types");

var _FormComponent = _interopRequireDefault(require("../components/FormComponent"));

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

// eslint-disable-next-line import/no-cycle
var FormDefinition = _flowRuntime["default"].tdz(function () {
  return _types.FormDefinition;
});

var FormProps = _flowRuntime["default"].tdz(function () {
  return _reduxForm.FormProps;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].intersection(_flowRuntime["default"].object(_flowRuntime["default"].property("formStructure", _flowRuntime["default"].ref(FormDefinition)), _flowRuntime["default"].property("history", _flowRuntime["default"].object()), _flowRuntime["default"].property("location", _flowRuntime["default"].object()), _flowRuntime["default"].property("match", _flowRuntime["default"].object()), _flowRuntime["default"].property("onSubmit", _flowRuntime["default"]["function"](_flowRuntime["default"].param("values", _flowRuntime["default"].object()), _flowRuntime["default"].param("page", _flowRuntime["default"].number()), _flowRuntime["default"].param("_arg2", _flowRuntime["default"]["function"](_flowRuntime["default"]["return"](_flowRuntime["default"].any()))), _flowRuntime["default"]["return"](_flowRuntime["default"].any()))), _flowRuntime["default"].property("queryParams", _flowRuntime["default"].object()), _flowRuntime["default"].property("submitted", _flowRuntime["default"]["boolean"]())), _flowRuntime["default"].ref(FormProps)));

var State = _flowRuntime["default"].type("State", _flowRuntime["default"].object(_flowRuntime["default"].property("completedPage", _flowRuntime["default"].number()), _flowRuntime["default"].property("page", _flowRuntime["default"].number()), _flowRuntime["default"].property("showButton", _flowRuntime["default"]["boolean"]()))); // $FlowFixMe - type context without breaking form render


var ButtonContext = /*#__PURE__*/React.createContext({
  hideButton: function hideButton() {
    return undefined;
  }
});
exports.ButtonContext = ButtonContext;

var getSubmitButtonText = function getSubmitButtonText(page, formStructure) {
  if (page === formStructure.pages.length) {
    if (formStructure.submitBtnText) {
      return formStructure.submitBtnText;
    }

    return 'Submit';
  }

  return 'Continue';
}; // removes 'component-validator' from component key such that for
// component-level validation, react-scroll scrolls to the parent component,
// rather than the validation error message


var removeValidatorString = function removeValidatorString(value) {
  if (value.split('.').pop() === 'component-validator') {
    var componentSplit = value.split('.').slice(0, -1);
    return componentSplit.join('.');
  }

  return value;
};

var onSubmitFail = function onSubmitFail(errors) {
  // eslint-disable-next-line no-underscore-dangle
  if (errors && errors._error) {
    _reactScroll.scroller.scrollTo('error-box', {
      offset: -40,
      smooth: true
    });
  } else if (errors) {
    var fieldErrors = (0, _utils.flatten)(errors);
    var fieldErrorNames = Object.keys(fieldErrors);
    var target = removeValidatorString(fieldErrorNames[0]);

    _reactScroll.scroller.scrollTo(target, {
      offset: -40,
      smooth: true
    });
  } else {
    // eslint-disable-next-line no-console
    console.error('Unknown error');
  }
};

var Form = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Form, _React$Component);

  var _super = (0, _createSuper2["default"])(Form);

  function Form(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Form);
    _this = _super.call(this, props, context);

    _this.hideButton = function () {
      _this.setState({
        showButton: false
      });
    };

    _this.prevPage = function () {
      var history = _this.props.history;
      var page = _this.state.page;
      var newPageNumber = page - 1;
      (0, _utils.scrollToTop)();

      _this.setState({
        page: newPageNumber
      });

      history.push("step".concat(newPageNumber).concat(history.location.search));
      (0, _gaPushToDataLayer["default"])(window.location.pathname, "Page ".concat(newPageNumber));
    };

    _this.nextPage = function () {
      var history = _this.props.history;
      var _this$state = _this.state,
          completedPage = _this$state.completedPage,
          page = _this$state.page;
      var newPageNumber = page + 1;
      (0, _utils.scrollToTop)();

      _this.setState({
        completedPage: page > completedPage ? completedPage + 1 : completedPage,
        page: newPageNumber
      });

      history.push("step".concat(newPageNumber).concat(history.location.search));
      (0, _gaPushToDataLayer["default"])(window.location.pathname, "Page ".concat(newPageNumber));
    };

    _this.setPage = function (selectedPage) {
      var history = _this.props.history;
      var completedPage = _this.state.completedPage;

      if (selectedPage <= completedPage + 1) {
        (0, _utils.scrollToTop)();

        _this.setState({
          page: selectedPage
        });

        history.push("step".concat(selectedPage).concat(history.location.search));
        (0, _gaPushToDataLayer["default"])(window.location.pathname, "Page ".concat(selectedPage));
      }
    };

    _this.resetForm = function () {
      var _this$props = _this.props,
          history = _this$props.history,
          reset = _this$props.reset;
      (0, _utils.scrollToTop)();
      reset();

      _this.setState({
        page: 1
      });

      history.push("step1".concat(history.location.search));
      (0, _gaPushToDataLayer["default"])(window.location.pathname, "Page 1");
    };

    _this.onPaymentFormSuccess = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(paymentId) {
        var _this$props2, dispatch, handleSubmit;

        return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props2 = _this.props, dispatch = _this$props2.dispatch, handleSubmit = _this$props2.handleSubmit; // Set the payment ID value so it is available to `onSubmit`

                _context.next = 3;
                return dispatch((0, _reduxForm.change)('form', 'payment.id', paymentId));

              case 3:
                return _context.abrupt("return", handleSubmit(_this.onSubmit)());

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.onSubmit = function (values) {
      var onSubmit = _this.props.onSubmit;
      var page = _this.state.page; // Progress form

      return onSubmit(values, page, _this.nextPage);
    };

    var _page = _this.props.match.params.page;
    var pageNum = _page ? parseInt(_page.match(/\d+$/), 10) : 1;
    _this.state = {
      completedPage: 0,
      page: pageNum,
      showButton: true
    };
    return _this;
  }

  (0, _createClass2["default"])(Form, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _gaPushToDataLayer["default"])(window.location.pathname, "Page ".concat(this.state.page));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // The below is required for the browser back and forward buttons to work
      if (this.props.location.pathname !== prevProps.location.pathname) {
        var historyPage = this.props.location.pathname;
        var pageNum = historyPage ? parseInt(historyPage.match(/\d+$/), 10) : 1; // eslint-disable-next-line react/no-did-update-set-state

        this.setState({
          page: pageNum
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          error = _this$props3.error,
          formStructure = _this$props3.formStructure,
          handleSubmit = _this$props3.handleSubmit,
          invalid = _this$props3.invalid,
          queryParams = _this$props3.queryParams,
          submitting = _this$props3.submitting,
          submitted = _this$props3.submitted;
      var _this$state2 = this.state,
          completedPage = _this$state2.completedPage,
          showButton = _this$state2.showButton,
          page = _this$state2.page;
      var formPage = formStructure.pages[page - 1];
      var isLastPage = formStructure && page === formStructure.pages.length;
      var noSuccessRedirect = queryParams && !queryParams.redirect && formStructure && formStructure.success && !formStructure.success.url;
      var submitButtonText = getSubmitButtonText(page, formStructure);

      if (isLastPage && noSuccessRedirect && submitted) {
        return /*#__PURE__*/React.createElement("section", {
          className: "section section__form group" // eslint-disable-next-line react/no-danger
          ,
          dangerouslySetInnerHTML: {
            __html: formStructure.success && formStructure.success.text ? formStructure.success.text : 'Thank you, your submission has been received.'
          }
        });
      }

      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        React.createElement(ButtonContext.Provider, {
          value: {
            hideButton: this.hideButton
          }
        }, /*#__PURE__*/React.createElement("section", {
          className: "section section__form group"
        }, formPage && /*#__PURE__*/React.createElement(_ProgressBar["default"], {
          form: formStructure,
          page: page,
          setPage: this.setPage
        }), /*#__PURE__*/React.createElement("div", {
          className: "col span_10_of_12 push_1"
        }, completedPage > 0 || page === 1 ? formPage ? /*#__PURE__*/React.createElement(React.Fragment, null, formPage.type === 'payment' ? /*#__PURE__*/React.createElement(_PaymentFormWrapper["default"], {
          formPage: formPage,
          onSuccess: this.onPaymentFormSuccess,
          submitBtnText: submitButtonText
        }) : /*#__PURE__*/React.createElement("form", {
          noValidate: "novalidate",
          onSubmit: handleSubmit(this.onSubmit)
        }, formPage.header && /*#__PURE__*/React.createElement(_Header["default"], {
          key: formPage.key,
          header: formPage.header
        }), formPage.components && formPage.components.map(function (component) {
          return /*#__PURE__*/React.createElement(_FormComponent["default"], {
            key: component.key,
            component: component,
            queryParams: queryParams
          });
        }), /*#__PURE__*/React.createElement("div", {
          className: "button-actions"
        }, page > 1 && showButton && /*#__PURE__*/React.createElement(_Button["default"], {
          arrow: "left",
          label: "Back",
          onClick: this.prevPage,
          level: "tertiary",
          type: "button"
        }), showButton && /*#__PURE__*/React.createElement(_Button["default"], {
          arrow: "right",
          disabled: submitting || submitted,
          invalid: invalid,
          label: submitButtonText,
          loading: submitting || submitted,
          level: "primary",
          type: "submit"
        })), formPage && formPage.footer && /*#__PURE__*/React.createElement(_Footer["default"], {
          footer: formPage.footer
        })), error && /*#__PURE__*/React.createElement("div", {
          className: "error-box",
          name: "error-box"
        }, error)) : /*#__PURE__*/React.createElement("h2", null, "Form not found") : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "Please reset the form to continue"), /*#__PURE__*/React.createElement(_Button["default"], {
          label: "Reset",
          onClick: this.resetForm,
          level: "tertiary",
          type: "button"
        })))))
      );
    }
  }]);
  return Form;
}(React.Component);

var _default = (0, _reduxForm.reduxForm)({
  form: 'form',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  onSubmitFail: onSubmitFail
})((0, _reactRouterDom.withRouter)(Form));

exports["default"] = _default;